import { api } from './apiClient';
import { enregistrerFichier } from './fichiers';

/**
 * Les documents produits par le serveur (ADR-0014), vus de l'ecran : on
 * demande, on recoit un fichier, on le remet au navigateur. Deux ecrans
 * demandent le bordereau — la liste des remises et la fiche d'une remise
 * — et deux copies du geste divergeraient.
 */
export async function telechargerBordereau(remiseId: string, reference: string): Promise<void> {
  const fichier = await api.telecharger(`/api/remises/${remiseId}/bordereau.pdf`);
  enregistrerFichier(fichier.contenu, fichier.nomFichier ?? `${reference}.pdf`);
}
